import { UserFeatures } from "@roc/feature-app-core";
import { insertIf } from "@roc/feature-utils";
import { SelectOption } from "@roc/ui";

export enum CounterPartyExpensesTab {
  ALL_PAYABLE = 'ALL_PAYABLE',
  PENDING_PAYABLE = 'PENDING_PAYABLE',
  ALL_RECEIVABLE = 'ALL_RECEIVABLE',
  PENDING_RECEIVABLE = 'PENDING_RECEIVABLE',
  RECEIVABLE_APPROVED = 'APPROVED_RECEIVABLE',
  ALL_BILL_RECEIVABLE = 'ALL_BILL_RECEIVABLE',
  BILL_RECEIVABLE = 'BILL_RECEIVABLE',
  PENDING_RECEIVABLE_BILL = 'PENDING_RECEIVABLE_BILL',
  PAYABLES_APPROVED = 'APPROVED_PAYABLE',
  ALL_PAYABLES_APPROVED = 'ALL_PAYABLES_APPROVED',
  LOAN_PAYABLE = 'LOAN_PAYABLE',
  LOAN_RECEIVABLE = 'LOAN_RECEIVABLE',
  PENDING_REFUNDS = 'PENDING_REFUNDS',
  ALL_REFUNDS = 'ALL_REFUNDS',
  PAYABLES_INVOICES_DASHBOARD = 'PAYABLES_INVOICES_DASHBOARD',
  PAYABLE = 'PAYABLE',
  RECEIVABLE = 'RECEIVABLE',
  BILL = 'BILL',
  VENDOR_PAYMENT = 'VENDOR_PAYMENT',
  PENDING_VENDOR_PAYMENT = 'PENDING_VENDOR_PAYMENT',
  APPROVED_VENDOR_PAYMENT = 'APPROVED_VENDOR_PAYMENT',
  ALL_VENDOR_PAYMENT = 'ALL_VENDOR_PAYMENT',
  VENDOR_PAYMENT_PAYABLES = 'VENDOR_PAYMENT_PAYABLES',
  VENDOR_LOANS = 'VENDOR_LOANS',
  VENDOR_APPROVAL = 'VENDOR_APPROVAL',
  VENDOR_CREATE_VENDORS = 'VENDOR_CREATE_VENDORS',
  RECEIVABLE_BILL_RECEIVABLES = 'RECEIVABLE_BILL_RECEIVABLES',
};

export const VENDOR_PAYMENT_TABS = [
  {
    value: CounterPartyExpensesTab.PENDING_VENDOR_PAYMENT,
    label: 'Pending',
  },
  {
    value: CounterPartyExpensesTab.APPROVED_VENDOR_PAYMENT,
    label: 'Approved',
  },
  {
    value: CounterPartyExpensesTab.ALL_VENDOR_PAYMENT,
    label: 'All',
  },
];

export const PAYABLES_TABS = [
  {
    value: CounterPartyExpensesTab.PENDING_PAYABLE,
    label: 'Pending',
  },
  {
    value: CounterPartyExpensesTab.PAYABLES_APPROVED,
    label: 'Approved',
  },
  {
    value: CounterPartyExpensesTab.ALL_PAYABLE,
    label: 'All',
  },
];

export const PAYABLES_APPROVED_TABS = [
  {
    value: CounterPartyExpensesTab.PAYABLES_APPROVED,
    label: 'Approved',
  },
  {
    value: CounterPartyExpensesTab.ALL_PAYABLES_APPROVED,
    label: 'All',
  },
];

export const LOAN_TABS = [
  {
    value: CounterPartyExpensesTab.LOAN_PAYABLE,
    label: 'Payables',
  },
  {
    value: CounterPartyExpensesTab.LOAN_RECEIVABLE,
    label: 'Receivables',
  },
];

export const RECEIVABLES_TABS = [
  {
    value: CounterPartyExpensesTab.PENDING_RECEIVABLE,
    label: 'Pending',
  },
  {
    value: CounterPartyExpensesTab.RECEIVABLE_APPROVED,
    label: 'Approved',
  },
  {
    value: CounterPartyExpensesTab.ALL_RECEIVABLE,
    label: 'All',
  },
];

export const RECEIVABLE_BILLS_TABS = [
  {
    value: CounterPartyExpensesTab.PENDING_RECEIVABLE_BILL,
    label: 'Pending',
  },
  {
    value: CounterPartyExpensesTab.BILL_RECEIVABLE,
    label: 'Billed',
  },
  {
    value: CounterPartyExpensesTab.ALL_BILL_RECEIVABLE,
    label: 'All',
  },
];

export interface Entity {
  label: string;
  value: string;
}

export enum ProtectiveAdvanceModalType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
};

export const BILL_TRANSACTION = 'BILL_TRANSACTION';
export const FRONTED = 'Fronted';

export const VENDOR_PAYMENT_TRANSACTION = 'VENDOR_PAYMENT_TRANSACTION';

export enum PayableReceivablesTypes {
  REJECTED = 'Rejected',
  PAID = 'Paid',
  APPROVED = 'Approved',
  PENDING = 'Pending',
  BILLED = 'Billed',
  PROCESSING = 'Processing'
};

export const getPayableReceivablesStatusOptions = (type: CounterPartyExpensesTab) => {
  return (
    [
      { label: PayableReceivablesTypes.PENDING, value: PayableReceivablesTypes.PENDING }
      ,
      ...insertIf(!type.includes('BILL'), [
        { label: PayableReceivablesTypes.APPROVED, value: PayableReceivablesTypes.APPROVED },
      ]),
      ...insertIf(type.includes('PAYABLE') || (type.includes('RECEIVABLE') && !type.includes('BILL')), [
        { label: PayableReceivablesTypes.PROCESSING, value: PayableReceivablesTypes.PROCESSING },
      ]),
      { label: PayableReceivablesTypes.PAID, value: PayableReceivablesTypes.PAID },
      ...insertIf(type.includes('BILL') || type.includes('RECEIVABLE'), [
        { label: PayableReceivablesTypes.BILLED, value: PayableReceivablesTypes.BILLED }
      ]),
      { label: PayableReceivablesTypes.REJECTED, value: PayableReceivablesTypes.REJECTED },
    ]
  )

}

export const REFUNDS_TABS = [
  {
    value: CounterPartyExpensesTab.PENDING_REFUNDS,
    label: 'Pending',
  },
  {
    value: CounterPartyExpensesTab.ALL_REFUNDS,
    label: 'All',
  },
];

export const getLoanVendorTabs = (userFeatures: UserFeatures) => [
  {
    value: CounterPartyExpensesTab.VENDOR_LOANS,
    label: 'Loans',
    hidden: false,
  },
  {
    value: CounterPartyExpensesTab.VENDOR_CREATE_VENDORS,
    label: 'Create',
    hidden: !userFeatures?.createVendorAllowed,
  },
  {
    value: CounterPartyExpensesTab.VENDOR_APPROVAL,
    label: 'Approval',
    hidden: !userFeatures?.approveVendorBankInformationAllowed,
  },
]

export const TYPES_OF_FEE: Array<SelectOption> = [
  { label: 'Appraisal Fee', value: 'Appraisal Fee' },
  { label: 'BPO Fee', value: 'BPO Fee' },
  { label: 'Courier Fee', value: 'Courier Fee' },
  { label: 'Delinquent Property Tax', value: 'Delinquent Property Tax' },
  { label: 'Force Placed Insurance', value: 'Force Placed Insurance' },
  { label: 'Legal Fee', value: 'Legal Fee' },
  { label: 'Miscellaneous Fee', value: 'Miscellaneous Fee' },
  { label: 'Property Preservation Fee', value: 'Property Preservation Fee' },
  { label: 'Real Estate Tax', value: 'Real Estate Tax' },
  { label: 'Recording Fee', value: 'Recording Fee' },
  { label: 'REO Insurance', value: 'REO Insurance' },
  { label: 'Title Fee', value: 'Title Fee' },
  { label: 'Sheriffs Fee', value: 'Sheriffs Fee' },
  { label: 'Town Fee', value: 'Town Fee' },
  { label: 'CEMA Processing Fee', value: 'CEMA Processing Fee' },
  { label: 'Insurance Admin Fee', value: 'Insurance Admin Fee' },
  { label: 'Personal Guaranty Fee', value: 'Personal Guaranty Fee' },
  { label: 'Credit Memo', value: 'Credit Memo' },
];

export const ACH_TRANSFER = 'ACH Transfer';
export const WIRE_TRANSFER = 'Wire Transfer';
export const APPROVED_ACH = 'APPROVED_ACH';
export const APPROVED_WIRE = 'APPROVED_WIRE';

export interface HistoryChange {
  fieldName: string;
  oldValue: string | null;
  newValue: string | null;
}

export interface HistoryEntry {
  recordId: string | number;
  changes: HistoryChange[];
  updatedBy: string;
  updateDate: string;
}